import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import swal from 'sweetalert';

import './plugins/MDB/css/bootstrap.min.css';
import './plugins/MDB/css/mdb.min.css';
import './plugins/MDB/css/style.min.css';
import './plugins/MDB/js/jquery-3.4.1.min.js';

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	swal,
	render: h => h(App)
}).$mount('#app');
